<template>
	<div>
		<breadcrumb :routerList="[{to:'/pricenew',title:'特价管理'},{to:'/pricenew',title:'特价列表'},{title:'特价详情'}]"/>
		<div class="h-content">
			<div class="h-row h-mrt0">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowCon">
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
									<h1>基本信息</h1>
								</div>
								<div class="h-pieceCon2">
									<div class="h-formLine Tejia">
										<el-form :model="shangbuneirong" label-position="right" ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine">
                                            <el-form-item label="项目名称" class="h-elformWrap-2" prop="formCon4">
                                                <el-input v-model="shangbuneirong.xiangmumingcheng" placeholder="齐鲁医院" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="formCon5">
                                                <el-input v-model="shangbuneirong.chanpinxinghao" placeholder="XM9874755TY" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="特价方式" class="h-elformWrap-2" prop="formCon6">
                                                <el-input v-model="shangbuneirong.tejiafangshi" placeholder="折扣" disabled="disabled"></el-input>
                                            </el-form-item>
                                            <el-form-item label="特价折扣/金额" class="h-elformWrap-2" prop="formCon7"> 
                                                <el-input v-model="shangbuneirong.tejiazhekoujine" placeholder="92折" disabled="disabled"></el-input>
                                            </el-form-item>
										</el-form>
									</div>
								</div>
							</div>
							<div class="h-pieceIn2">
								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
									<h1>资料展示</h1>
								</div>
								<el-form 
                                    label-position="right" 
                                    ref="formLabelAlign2" 
                                    :inline="true"
									class="demo-ruleForm h-formbLine" 
                                    style="padding-top:0rem">
                                    <el-form-item label="证明资料" class="h-elformWrap-1" prop="upload">
                                        <brupload
                                            :refid = "zancuntijiao"
                                            :reftype = "zhengmingziliao"
                                            >
                                        </brupload>
                                    </el-form-item>
								</el-form>
							</div>

<!--							<div class="h-pieceIn2">-->
<!--								<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">-->
<!--									<h1>审批历史</h1>-->
<!--								</div>-->
<!--								<div class="h-pieceCon2" style="width:100%;padding:20px 50px;background:#fcfcfc;height:220px;border-radius:10px;border:1px solid #ccc;position:relative">-->
<!--                                    <div class="stepBox">-->
<!--                                        <div class="step" v-for="(item,index) in list" :key="index">-->
<!--                                            <div v-if="item.isactive==1" class="leftstep" style="border-color:#f90214;color:#f90214;">{{item.title}}-->
<!--                                                <div class="times">-->
<!--                                                    <span>{{item.time}}</span>-->
<!--                                                    <span style="margin-top:10px;">未通过审批</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div v-if="item.isactive==0" class="leftstep">{{item.title}}-->
<!--                                                <div class="times">-->
<!--                                                    <span>{{item.time}}</span>-->
<!--                                                    <span style="margin-top:10px;">通过审批</span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div v-if="index<3" class="rightstep">-->
<!--                                                <div v-if="item.isactive==1" class="circle" style="border-color:#f90214;">-->
<!--                                                    <img src="../../../assets/images/checkerror.png" alt="" style="position: absolute;top: -10%;left: -10%;margin:0">-->
<!--                                                </div>-->
<!--                                                <div v-if="item.isactive==0" class="circle">-->
<!--                                                    <img src="../../../assets/images/checksuccess.png" alt="">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--								</div>-->
<!--							</div>-->






<!--								<template>-->
<!--									<el-button class="h-btn h-bBtn h-bgwhite" @click="chakanjindu()">查看进度</el-button>-->
<!--								</template>-->



<!--							<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>-->
						</div>
					</div>
				</div>
			</div>
			<div class="h-txtCenter h-mrt60">
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="fanhuishangyiye" >返回</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import ss from '../../../api/SystemService'
const cityOptions = [1,2,3,4,5,6,7,8];
export default {
	data(){
        return{
            instid:'',
            showhistory:false,
            //特价版本id
            zancuntijiao:'',
            //资料名字
            zhengmingziliao:'zhengmingziliao',
            shangbuneirong:{
            xiangmumingcheng:'',
            chanpinxinghao:'',
            tejiafangshi:'',
            tejiazhekoujine:'',
            },



        list:[
            {
                title:'型号部门',
                isactive:0,
                time:'2019/09/10 18:00:00',
            },
            {
                title:'采购经理',
                isactive:0,
                time:'2019/09/10 18:00:00',
            },
            {
                title:'小微主',
                isactive:0,
                time:'2019/09/10 18:00:00',
            },
            {
                title:'财务经理',
                isactive:0,
                time:'2019/09/10 18:00:00',
            }
        ],
        //带线表单
            formLabelAlign: {
            formCon4: '',
            formCon5: '',
            formCon6:'',
            formCon7:'',
        },
            multipleSelection: [],
            tableData2: [{
                reporter: 'HU87889976432',
                visitTime:'XM8765444324',
                num:'12',
                price:'268,000元',
                grade:'268,000元'
                },{
                reporter: 'HU87889976432',
                visitTime:'XM8765444324',
                num:'12',
                price:'268,000元',
                grade:'268,000元'
                },{
                reporter: 'HU87889976432',
                visitTime:'XM8765444324',
                num:'12',
                price:'268,000元',
                grade:'268,000元'
                },{
                reporter: 'HU87889976432',
                visitTime:'XM8765444324',
                num:'12',
                price:'268,000元',
                grade:'268,000元'
                },{
                reporter: 'HU87889976432',
                visitTime:'XM8765444324',
                num:'12',
                price:'268,000元',
                grade:'268,000元'
                }
            ],
        }
    },
	//加载页面默认执行
	created() {
		//默认首次取数
		this.gettableels();
	},
    methods:{
		fanhuishangyiye(){
			this.$router.push({path: '/pricenew'});
		},
		//查看进度
		chakanjindu(){
			this.showhistory = true;
		},
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		gettableels(){
			//拿到id
			this.idmsg = this.$router.history.current.query.id;
			var id ={
				id: this.idmsg,
			}
			this.zancuntijiao = this.idmsg;
			//取页面参数
			ss.specialController.tejiaxiangqing(id).then(rd => {
				this.shangbuneirong.xiangmumingcheng = rd.prname;
				this.shangbuneirong.chanpinxinghao = rd.chanpinxinghao;
				this.shangbuneirong.tejiafangshi = rd.tejiafangshi=='1'?'金额':rd.tejiafangshi=='2'?'折扣':'';
				this.shangbuneirong.tejiazhekoujine = rd.tejiafangshi=='1'?rd.chanpinzhekoujine:rd.tejiafangshi=='2'?rd.zhekou:'';
				this.instid = rd.instid;

			})
		},
    },
}
</script>
<style scoped>
/* .downLond{
    height: 33px;
    line-height: 33px;
    margin: 10px;
    display: flex;
    font-size: 0.2rem;
}
.downLond .texts{
    margin-left: 20px;
    color: #0964ae;
    text-decoration: underline;
    cursor: pointer;
}
.downLond .yulan{
    color: #727272;
    cursor: pointer;
    margin-left: 20px;
}
.downLond .down{
    color: #0964ae;
    cursor: pointer;
    text-decoration: underline;
    margin-left: 20px;
} */
/* .stepBox{
    width: 100%;
    display: flex;
    flex-wrap:wrap;
    justify-content: flex-start;
    align-items:center;
    margin-left: 5%;
}
.stepBox .step{
    width: 25%;
    display: flex;
    justify-content: flex-start;
    align-items:center;
}
.stepBox .step .leftstep{
    width: 103px;
	background-color: #fcfcfc;
	border-radius: 4px;
	border: solid 4px #0e75e9;
    font-size: 24px;
    color: #0e75e9;
    text-align: center;
    padding: 16px 12px;
    position: relative;
    flex-shrink: 0

}
.stepBox .step .leftstep .times{
    width: 140px;
    position: absolute;
    top: 120px;
    left: -20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #595959;
}
.stepBox .step .rightstep{
    width: 240px;
    height: 10px;
	background-image: linear-gradient(-90deg, 
		#0056a4 0%, 
		#3291fd 100%), 
	linear-gradient(
		#0e75e9, 
		#0e75e9);
	background-blend-mode: normal, 
		normal;
    position: relative;
}
.stepBox .step .rightstep .circle{
    width: 50px;
	height: 50px;
	background-color: #fcfcfc;
    border: 4px solid #3291fd;
    overflow: hidden;
    border-radius: 50%;
    position: absolute;
    top: -18px;
    left: 50%;
    transform: translateX(-25px);
}
.stepBox .step .rightstep .circle img{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
} */
.Tejia{
    margin-top: 0.38rem;
}
</style>
<style>
.Tejia .h-formbLine .el-form-item__label{
    width: 34%;
    text-align: right;
}
.Tejia .h-formbLine .el-form-item__content{
    width: 66%;
}
.Tejia .h-formbLine .h-elformWrap-2{
    width: 33.333%;
    padding-right: 0.5rem
}
.Tejia .h-formbLine .h-elformWrap-1{
    width: 100%;
    padding-right: 0.5rem
}
.Tejia .h-formbLine .h-elformWrap-1 .el-form-item__label{
    width: 9.7%;
}
.Tejia .h-formbLine .h-elformWrap-1 .el-form-item__content{
    width: 90.3%;
}
</style>
